export default () => ({
  vehicle: null,
})
